/**
 * usePorterThreads — React Query hook for the rPI Porter inbox (E-102 P1-7a).
 *
 * Polls every 60 seconds, matching the OmniDesk Gmail pull-cron cadence
 * (~1-2 min, D-1). The old 5 s cadence was sized for Chatwoot webhook echoes;
 * email transport does not need it. Phase 2+ will migrate to a WebSocket
 * pub-sub channel once the S3 event bus lands.
 */
import { listThreads, type ThreadListFilters } from '@/api/porter-threads';
import { useQuery } from '@tanstack/react-query';

const POLL_INTERVAL_MS = 60_000;
const STALE_TIME_MS = 30_000;

export function usePorterThreads(filters: ThreadListFilters) {
  return useQuery({
    queryKey: ['porter', 'threads', filters] as const,
    queryFn: () => listThreads(filters),
    // CR finding #18: visibility-aware polling — pause when browser tab is hidden
    // to avoid wasted poll budget on background tabs.
    refetchInterval: () =>
      typeof document !== 'undefined' && document.visibilityState === 'hidden'
        ? false
        : POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    staleTime: STALE_TIME_MS,
  });
}
